<template>
  <div class="bg-vendor-light-pink">
    <div class="max-w-screen-xl mx-auto">
      <div class="px-6 xl:px-0 pt-10 pb-16 md:pt-20 md:pb-32">
          <div class="flex flex-col md:flex-row">
            <div class="content md:mx-16 lg:mx-48 text-center">
              <img
                src="../assets/images/collaboration.jpg"
                alt="GR Foundation Collaboration"
              />
              <div
                class="text hidden md:block text-vendor-light-blue leading-relaxed pt-12 text-2xl font-medium"
              >
                <p>
                  These are our main projects. We hope to keep growing and having
                  more collaborators to help in the future.
                </p>
                <br />
                <p>
                  GRF has helped those associations through the funding of kid's
                  education, scholarships for excelling students, clothes, nourriture
                  and medicines.
                </p>
              </div>
            </div>
            <div class="title md:absolute">
              <h1 class="ts pt-6 text-vendor-pink font-bold">
                Collaborations
              </h1>
              <Underline class="bg-vendor-light-blue" />
              <div class="hidden md:block max-w-md h-24 text-vendor-light-blue uppercase">
                <p class="subtitle-colab">
                  GoldenRace Foundation helps non profit organizations around the
                  world.
                </p>
              </div>
            </div>
          </div>
          <div class="text block md:hidden text-vendor-light-blue leading-relaxed">
            <p class="uppercase font-bold">
              GoldenRace Foundation helps non profit organizations around the world.
            </p>
            <br />
            <p>
              These are our main projects. We hope to keep growig and having more
              collaborators to help in the future.
            </p>
            <br />
            <p>
              GRF has helped those associations through the funding of kid's education,
              scholarship for excelling students, clothes, nourriture and medicines.
            </p>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import Underline from "@/components/parts/Underline";

export default {
  name: "Collaborations",
  components: {
    Underline,
  },
};
</script>

<style scoped>
  .subtitle-colab {
    font-size: 16px;
    font-weight: 700;
    color: #586DEA;
  }

  @media screen and (min-width: 767px) {
    .subtitle-colab {
      font-size: 22px;
    }
  }
</style>